import Page from "@insite/mobius/Page/";

Object.assign(Page.defaultProps, {
    padding: 0,
    fullWidth: [true, true, true, true, true],
});
